import {ReactComponent as InfoCircleIcon} from "../../../assets/svg/info-cirlce.svg";
import React from 'react';

export const InfoAlert: React.FC<React.PropsWithChildren> = ({children}) => {
    return (
        <div className="bg-[#383e45] rounded-[4px] px-5 py-[10px]">
            <div className="flex gap-[15px]">
                <InfoCircleIcon className="flex-shrink-0" />
                <div className="text-white opacity-85 text-sm/[24px] font-normal w-full">{children}</div>
            </div>
        </div>
    )
}
